import React from 'react';
import { HourglassIcon } from 'lucide-react';
import { useCountdown } from '../utils/useCountdown';
type CountdownProps = {
  className?: string;
  tone?: 'dark' | 'light';
};
export function CountdownTimer({
  className = '',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hrs'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className={`flex items-stretch justify-center gap-1.5 ${className}`} role="timer" aria-label="Offer countdown" data-id="element-51" data-mp="3h0pgtkd9ntx6">
      {units.map(unit => <div key={unit.label} className={`min-w-[54px] rounded-md px-2 py-1 text-center sm:min-w-[66px] ${tone === 'dark' ? 'bg-night ring-1 ring-white/10' : 'bg-white ring-1 ring-night/10'}`} data-id="element-52" data-mp="324zxjtzgtuw5">
          <span className={`block font-head text-lg font-bold tabular-nums leading-none sm:text-2xl ${tone === 'dark' ? 'text-cta' : 'text-brand'}`} data-id="element-53" data-mp="10dmvrdsso34b">
            {unit.value}
          </span>
          <span className={`block text-[8px] font-semibold uppercase tracking-widest sm:text-[9px] ${tone === 'dark' ? 'text-silver/60' : 'text-night/50'}`} data-id="element-54" data-mp="y04zcbnfg0uq">
            {unit.label}
          </span>
        </div>)}
    </div>;
}
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-40 w-full bg-brand px-3 py-1.5 text-center" data-id="element-55" data-mp="12solvy43e6bo">
      <p className="flex flex-wrap items-center justify-center gap-x-1.5 font-head text-[11px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-56" data-mp="f33selabbqo5">
        <HourglassIcon className="h-3.5 w-3.5 text-mustard" aria-hidden="true" data-id="element-57" data-mp="o2qtf5z4qugo" />
        Launch offer ends in:
        <span className="tabular-nums text-mustard" data-id="element-58" data-mp="k0vug84o8t62">
          {hours}
          <span className="text-[9px] text-white/70" data-id="element-59" data-mp="k3rq1pt1r5rc"> HRS </span>: {minutes}
          <span className="text-[9px] text-white/70" data-id="element-60" data-mp="1zgchent96q0m"> MIN </span>: {seconds}
          <span className="text-[9px] text-white/70" data-id="element-61" data-mp="1vfiw82773pbf"> SEC</span>
        </span>
      </p>
    </div>;
}
export function OfferBar() {
  return <section aria-label="Limited-time offer" className="w-full bg-panel px-4 py-8" data-id="element-62" data-mp="s7r7baimmb7p">
      <div className="mx-auto max-w-xl rounded-2xl border border-mustard/60 bg-night p-4 text-center" data-id="element-63" data-mp="x36ke08t8332">
        <span className="inline-block rounded-full bg-mustard px-2.5 py-0.5 font-head text-[10px] font-bold uppercase tracking-wide text-night" data-id="element-64" data-mp="124m1xibs3rgp">
          Limited-Time Offer
        </span>
        <h2 className="mt-1.5 font-head text-lg font-bold uppercase leading-none text-white sm:text-2xl" data-id="element-65" data-mp="9gqb2u8w4tru">
          The launch price ends in:
        </h2>
        <CountdownTimer className="mt-2" data-id="element-66" data-mp="ifbo69vlfgl8" />
        <p className="mx-auto mt-2 max-w-sm text-[11px] leading-snug text-silver" data-id="element-67" data-mp="ieadw7meiy4k">
          After that, the price may increase and the strategic bonuses may no longer be included.
        </p>

        <div className="mx-auto mt-3 max-w-xs" data-id="element-68" data-mp="3mta1tfsci6me">
          <div className="flex items-center justify-between font-head text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-69" data-mp="3qvn6s1z9q0i4">
            <span className="text-cta" data-id="element-70" data-mp="3jb2x4iwizc6p">Launch Offer</span>
            <span className="text-mustard" data-id="element-71" data-mp="3j9rr0cflxscf">Limited Availability</span>
          </div>
          <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={78} aria-valuemin={0} aria-valuemax={100} aria-label="Availability claimed" data-id="element-72" data-mp="3eaydik0bm1c9">
            <div className="h-full rounded-full bg-mustard" style={{
            width: '78%'
          }} data-id="element-73" data-mp="35eh01a4hhrdc" />
          </div>
        </div>
      </div>
    </section>;
}